import styled from '@emotion/styled';
import InfoTabs from 'components/InfoTabs';
import Form from 'components/Form';
import PropTypes from 'prop-types';

const Container = styled.section`
  width: 100%;

  margin: 0 auto;
  padding: 4rem 2rem;
  display: flex;
  flex-direction: column-reverse;
  gap: 8rem;

  ${({ theme }) => theme.mediaQueries.lg} {
    padding: 8rem 3rem;
    flex-direction: row;
    gap: 4rem;
  }
`;
const Areas = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  ${({ theme }) => theme.mediaQueries.sm} {
    gap: 4rem;
  }
`;
const Title = styled.h2`
  ${({ theme }) => theme.mixins.Mono};
  color: ${({ theme }) => theme.colors.gray};
  text-align: center;
  display: block;

  ${({ theme }) => theme.mediaQueries.lg} {
    text-align: left;
    display: none;
  }
`;

const HomeContact = ({ faqTabs, id = '' }) => {
  return (
    <Container id={id}>
      <Areas>
        <Title>Frequently Asked Questions</Title>
        <InfoTabs faqTabs={faqTabs} />
      </Areas>
      <Areas>
        <Title>Contact Me</Title>
        <Form />
      </Areas>
    </Container>
  );
};
HomeContact.propTypes = {
  faqTabs: PropTypes.array.isRequired,
  id: PropTypes.string,
};
export default HomeContact;
